
import {
  Component, Emit, InjectReactive, Prop, Vue,
} from 'nuxt-property-decorator'

export interface ITab {
  count : number
  active : number
}

@Component({ name: 'BaseTabElement' })
export default class BaseTabElement extends Vue {
  @InjectReactive('tab') tab! : ITab

  @Prop() title ?: string

  @Prop() iconName ?: string

  private index : number = 0

  created () {
    this.tab.count += 1
    this.index = this.tab.count - 1
  }

  private get visible () : boolean {
    return this.index === this.tab.active
  }

  @Emit('scroll')
  private scroll (event : Event) : Event {
    return event
  }
}
